(() => {
  const MESSAGES = {
    hu: {
      missing_order: 'Add meg a rendelésszámot.',
      missing_email: 'Add meg az e-mail címet.',
      invalid_email: 'Érvénytelen e-mail cím.',
      invalid_tax: 'Válassz érvényes egészségpénztárat a listából.',
      missing_fields: 'Töltsd ki az EP számlához szükséges mezőket.',
      missing_fund: 'Válassz egészségpénztárat a listából.',
      funds_error: 'Nem sikerült betölteni az egészségpénztárakat. Próbáld újra később.',
      saving: 'Mentés…',
      saved: 'A számlázási adatok sikeresen mentve. A számla megközelítőleg 20–30 perc múlva érkezik.',
      fallback_saved: 'Adatok sikeresen elküldve! A számla megközelítőleg 20–30 perc múlva érkezik. Ügyfélszolgálatunk rögzíti a rendeléshez.',
      proxy_missing: 'A mentés jelenleg nem elérhető. Kérjük, írj az ügyfélszolgálatnak a rendelésszámmal.',
      generic_error: 'Nem sikerült menteni. Próbáld újra, vagy írj az ügyfélszolgálatnak.',
      invalid_order: 'Nem található rendelés ezzel az e-mail címmel.',
      edit_window_expired: 'A módosítási időszak lejárt (15 perc a rendelés után). Írj az ügyfélszolgálatnak.',
      already_submitted: 'Az adatok már rögzítve lettek. További módosítás nem lehetséges.',
      form_locked: 'Az adatok már rögzítve lettek ehhez a rendeléshez.',
    },
    en: {
      missing_order: 'Enter your order number.',
      missing_email: 'Enter your email address.',
      invalid_email: 'Invalid email address.',
      invalid_tax: 'Select a valid health fund from the list.',
      missing_fields: 'Fill in all required health fund invoice fields.',
      missing_fund: 'Select a health fund from the list.',
      funds_error: 'Could not load health funds. Please try again later.',
      saving: 'Saving…',
      saved: 'Invoice details saved successfully. Your invoice should arrive in approximately 20–30 minutes.',
      fallback_saved: 'Details submitted successfully. Your invoice should arrive in approximately 20–30 minutes.',
      proxy_missing: 'Saving is currently unavailable. Please contact support with your order number.',
      generic_error: 'Could not save. Try again or contact support.',
      invalid_order: 'No order found for this email address.',
      edit_window_expired: 'The edit window has expired (15 minutes after order). Please contact support.',
      already_submitted: 'Invoice details were already submitted and cannot be changed.',
      form_locked: 'Invoice details are already saved for this order.',
    },
  };

  function getLocale(root) {
    const lang = (root.getAttribute('lang') || document.documentElement.lang || 'hu').toLowerCase();
    return lang.startsWith('en') ? 'en' : 'hu';
  }

  function t(locale, key) {
    return (MESSAGES[locale] && MESSAGES[locale][key]) || MESSAGES.hu[key] || key;
  }

  function normalizeOrderName(value) {
    const trimmed = (value || '').trim();
    if (!trimmed) return '';
    return trimmed.startsWith('#') ? trimmed : `#${trimmed}`;
  }

  function setNotice(el, message, type) {
    if (!el) return;
    el.textContent = message || '';
    el.hidden = !message;
    el.classList.toggle('ep-invoice__alert--success', type === 'success');
    el.classList.toggle('ep-invoice__alert--error', type === 'error');
    if (message && type === 'success') {
      el.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }
  }

  function getSubmitLabelEl(button) {
    if (!button) return null;
    return button.querySelector('span') || button;
  }

  function setSubmitLabel(button, text) {
    const labelEl = getSubmitLabelEl(button);
    if (labelEl) labelEl.textContent = text;
  }

  function disableForm(form, submitButton) {
    if (!form) return;
    form.querySelectorAll('input, select, button').forEach((el) => {
      el.disabled = true;
    });
    if (submitButton) submitButton.disabled = true;
  }

  function syncEpFields(form, show) {
    const root = form.closest('[data-ep-invoice-root]');
    const fields = root && root.querySelector('[data-ep-fields]');
    if (!fields) return;

    fields.hidden = !show;
    fields.querySelectorAll('[data-ep-required-when-yes]').forEach((input) => {
      input.required = show;
      if (!show) input.setAttribute('aria-invalid', 'false');
    });
    if (show) syncFundSelection(form);
  }

  function syncFundSelection(form) {
    const select = form.querySelector('[data-ep-fund-select]');
    const taxInput = form.querySelector('[data-ep-tax-input]');
    const addressWrap = form.querySelector('[data-ep-address-wrap]');
    const addressDisplay = form.querySelector('[data-ep-address-display]');
    if (!select || !taxInput) return;

    const option = select.options[select.selectedIndex];
    const tax = option && option.dataset.tax ? option.dataset.tax : '';
    const address = option && option.dataset.address ? option.dataset.address : '';

    taxInput.value = tax;

    if (addressWrap && addressDisplay) {
      if (address) {
        addressDisplay.textContent = address;
        addressWrap.hidden = false;
      } else {
        addressDisplay.textContent = '';
        addressWrap.hidden = true;
      }
    }
  }

  function readForm(form, alwaysEp) {
    const data = new FormData(form);
    const epRequest = alwaysEp ? 'Igen' : String(data.get('EP_igenyles') || 'Nem');
    const attributes = {
      EP_igenyles: epRequest,
      EP_neve: String(data.get('EP_neve') || '').trim(),
      EP_szama: String(data.get('EP_szama') || '').trim(),
      tag_neve: String(data.get('tag_neve') || '').trim(),
      tag_szama: String(data.get('tag_szama') || '').trim(),
    };

    if (epRequest !== 'Igen') {
      attributes.EP_neve = '';
      attributes.EP_szama = '';
      attributes.tag_neve = '';
      attributes.tag_szama = '';
    }

    return {
      order_name: normalizeOrderName(data.get('order_name')),
      email: String(data.get('email') || '').trim().toLowerCase(),
      attributes,
    };
  }

  function validatePayload(payload, locale, allowedTaxNumbers) {
    if (!payload.order_name) return t(locale, 'missing_order');
    if (!payload.email) return t(locale, 'missing_email');
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(payload.email)) return t(locale, 'invalid_email');

    if (payload.attributes.EP_igenyles === 'Igen') {
      if (!payload.attributes.EP_neve) return t(locale, 'missing_fund');
      if (!payload.attributes.EP_szama || !allowedTaxNumbers.has(payload.attributes.EP_szama)) {
        return t(locale, 'invalid_tax');
      }
      if (!payload.attributes.tag_neve || !payload.attributes.tag_szama) {
        return t(locale, 'missing_fields');
      }
    }

    return '';
  }

  async function submitPayload(proxyUrl, payload) {
    const response = await fetch(proxyUrl, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      credentials: 'same-origin',
      body: JSON.stringify(payload),
    });

    let body = {};
    try {
      body = await response.json();
    } catch (_error) {
      body = {};
    }

    return { response, body };
  }

  async function submitContactFallback(payload) {
    const attrs = payload.attributes;
    const formData = new FormData();
    formData.append('form_type', 'contact');
    formData.append('utf8', '✓');
    formData.append('contact[tags]', 'ep-invoice');
    formData.append('contact[email]', payload.email);
    formData.append('contact[name]', attrs.tag_neve || 'EP számla űrlap');
    formData.append('contact[Rendelésszám]', payload.order_name);
    formData.append('contact[EP igénylés]', attrs.EP_igenyles);
    formData.append('contact[Egészségpénztár]', attrs.EP_neve || '');
    formData.append('contact[Adószám]', attrs.EP_szama || '');
    formData.append('contact[Tag neve]', attrs.tag_neve || '');
    formData.append('contact[Tagi azonosító]', attrs.tag_szama || '');

    const response = await fetch('/contact', {
      method: 'POST',
      body: formData,
      credentials: 'same-origin',
      redirect: 'follow',
    });

    return response.status < 500;
  }

  function populateFundSelect(select, funds, placeholder, selectedName) {
    if (!select) return;
    const previous = selectedName || select.value;
    select.innerHTML = '';

    const placeholderOption = document.createElement('option');
    placeholderOption.value = '';
    placeholderOption.textContent = placeholder;
    select.appendChild(placeholderOption);

    funds.forEach((fund) => {
      const option = document.createElement('option');
      option.value = fund.name;
      option.textContent = fund.name;
      option.dataset.tax = fund.taxNumber || '';
      option.dataset.address = fund.address || '';
      if (previous && previous === fund.name) {
        option.selected = true;
      }
      select.appendChild(option);
    });
  }

  async function loadFundConfig(configUrl) {
    const response = await fetch(configUrl, {
      method: 'GET',
      headers: { Accept: 'application/json' },
      credentials: 'same-origin',
    });
    if (!response.ok) throw new Error('config_fetch_failed');
    const body = await response.json();
    const funds = Array.isArray(body.epFunds) ? body.epFunds : [];
    return {
      funds,
      allowedTaxNumbers: new Set(funds.map((fund) => fund.taxNumber).filter(Boolean)),
    };
  }

  async function initRoot(root) {
    if (root.dataset.epInitialized === 'true') return;
    root.dataset.epInitialized = 'true';

    const locale = getLocale(root);
    const alwaysEp = root.dataset.alwaysEp === 'true';
    const formLocked = root.dataset.formLocked === 'true';
    const form = root.querySelector('[data-ep-invoice-form]');
    const toggle = root.querySelector('[data-ep-toggle]');
    const fields = root.querySelector('[data-ep-fields]');
    const fundSelect = form && form.querySelector('[data-ep-fund-select]');
    const submitButton = root.querySelector('[data-ep-submit]');
    const successEl = root.querySelector('[data-ep-success]');
    const errorEl = root.querySelector('[data-ep-error]');
    const proxyUrl = root.dataset.proxyUrl || '/apps/glux-ep/update';
    const configUrl = root.dataset.configUrl || '/apps/glux-ep/config';
    const placeholder = fundSelect ? fundSelect.dataset.placeholder || '' : '';
    const selectedName = fundSelect ? fundSelect.dataset.selectedName || '' : '';

    let allowedTaxNumbers = new Set(
      fundSelect
        ? [...fundSelect.options].map((option) => option.dataset.tax).filter(Boolean)
        : []
    );

    if (formLocked && errorEl) {
      setNotice(errorEl, t(locale, 'form_locked'), 'error');
    }

    if (alwaysEp && form) {
      syncEpFields(form, true);
    }

    const params = new URLSearchParams(window.location.search);
    const orderParam = params.get('order');
    const emailParam = params.get('email');
    const orderInput = form && form.querySelector('[name="order_name"]');
    const emailInput = form && form.querySelector('[name="email"]');
    if (orderInput && orderParam && !orderInput.value) {
      orderInput.value = normalizeOrderName(orderParam);
    }
    if (emailInput && emailParam && !emailInput.value) {
      emailInput.value = String(emailParam).trim().toLowerCase();
    }

    if (fundSelect) {
      fundSelect.addEventListener('change', () => syncFundSelection(form));
      try {
        const { funds, allowedTaxNumbers: loadedTaxNumbers } = await loadFundConfig(configUrl);
        if (funds.length) {
          populateFundSelect(fundSelect, funds, placeholder, selectedName);
          allowedTaxNumbers = loadedTaxNumbers;
        }
      } catch (_error) {
        setNotice(errorEl, t(locale, 'funds_error'), 'error');
      }
      syncFundSelection(form);
    }

    if (toggle && fields && !alwaysEp) {
      const syncFields = () => {
        syncEpFields(form, toggle.value === 'Igen');
      };
      toggle.addEventListener('change', syncFields);
      syncFields();
    }

    if (!form || formLocked) return;

    const originalSubmitLabel = getSubmitLabelEl(submitButton)?.textContent || '';

    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      setNotice(successEl, '', 'success');
      setNotice(errorEl, '', 'error');

      syncFundSelection(form);
      const payload = readForm(form, alwaysEp);
      const validationError = validatePayload(payload, locale, allowedTaxNumbers);
      if (validationError) {
        setNotice(errorEl, validationError, 'error');
        return;
      }

      if (submitButton) {
        submitButton.disabled = true;
        setSubmitLabel(submitButton, t(locale, 'saving'));
      }

      let succeeded = false;

      try {
        const { response, body } = await submitPayload(proxyUrl, payload);

        if (response.status === 404) {
          const fallbackOk = await submitContactFallback(payload);
          if (fallbackOk) {
            setNotice(successEl, t(locale, 'fallback_saved'), 'success');
            form.hidden = true;
            disableForm(form, submitButton);
            succeeded = true;
            return;
          }
          setNotice(errorEl, t(locale, 'proxy_missing'), 'error');
          return;
        }

        if (body.error === 'edit_window_expired') {
          setNotice(errorEl, t(locale, 'edit_window_expired'), 'error');
          disableForm(form, submitButton);
          return;
        }

        if (body.error === 'already_submitted') {
          setNotice(errorEl, t(locale, 'already_submitted'), 'error');
          disableForm(form, submitButton);
          return;
        }

        if (response.status === 403 || body.error === 'invalid_order') {
          setNotice(errorEl, t(locale, 'invalid_order'), 'error');
          return;
        }

        if (!response.ok || body.success !== true) {
          setNotice(errorEl, body.message || t(locale, 'generic_error'), 'error');
          return;
        }

        setNotice(successEl, t(locale, 'saved'), 'success');
        form.hidden = true;
        disableForm(form, submitButton);
        succeeded = true;
      } catch (_error) {
        setNotice(errorEl, t(locale, 'generic_error'), 'error');
      } finally {
        if (submitButton && !succeeded) {
          submitButton.disabled = false;
          setSubmitLabel(submitButton, originalSubmitLabel);
        }
      }
    });
  }

  function ensureSubmitButtonStyles() {
    if (document.getElementById('ep-invoice-submit-style')) return;
    const style = document.createElement('style');
    style.id = 'ep-invoice-submit-style';
    style.textContent = `
      .ep-invoice .ep-invoice__submit.btn {
        --background: var(--color-accent-section, var(--color-accent, #00838f));
        --background-hover: var(--color-button-hover-block, var(--color-base-section, var(--color-base, #16255c)));
        background-color: var(--background) !important;
        border: 0 !important;
        border-radius: 8px !important;
        overflow: hidden;
        color: #ffffff !important;
        -webkit-appearance: none;
        appearance: none;
      }
      .ep-invoice .ep-invoice__submit.btn::before,
      .ep-invoice .ep-invoice__submit.btn::after {
        content: none !important;
        display: none !important;
      }
      .ep-invoice .ep-invoice__submit.btn > span {
        color: #ffffff !important;
      }
      .ep-invoice .ep-invoice__submit.btn:hover,
      .ep-invoice .ep-invoice__submit.btn:focus-visible {
        background-color: var(--background-hover) !important;
        color: #ffffff !important;
      }
      .ep-invoice .ep-invoice__submit.btn:disabled,
      .ep-invoice .ep-invoice__submit.btn:disabled > span {
        color: #ffffff !important;
        opacity: 0.72;
      }
    `;
    document.head.appendChild(style);
  }

  function init() {
    ensureSubmitButtonStyles();
    document.querySelectorAll('[data-ep-invoice-root]').forEach((root) => {
      initRoot(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
